import React from "react";
import { Typography, Box, Button } from "@mui/material";
import PartnerCard from "../Affiliate/PartnerCard";
import PersonCard from "../Affiliate/PersonCard";
import Valentin_Grimm from "../../assets/Contributors/Valentin_Grimm.jpg";
import Jessica_Rubart from "../../assets/Contributors/Jessica_Rubart.jpg";
import Laura_Geiger from "../../assets/Contributors/Laura_Geiger.jpg";
import Gudrun_Faller from "../../assets/Contributors/Gudrun_Faller.jpg";
import TH_OWL from "../../assets/Contributors/TH_OWL.png";
import HSG from "../../assets/Contributors/HS-Gesundheit.jpg";
import MJZ from "../../assets/Contributors/MJZ.jpg";
import UK_NRW from "../../assets/Contributors/UK_NRW.jpg";
import { useTranslation } from "react-i18next";
import { toPublications } from "../../utils/routes";
import { ArrowForward, School } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Publications from "../Publications/Publications";

export default function ProjektOnboarding() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const standardTypo = {
    mb: 2,
  };

  return (
    <Box>
      <Typography variant="h2" sx={{ mt: 3 }}>
        {t("welcomeProjectTitle")}
      </Typography>
      <Box sx={{ pt: { xs: 2, sm: 3 } }}>
        <Typography align="left" sx={standardTypo}>
          {t("welcomeProjectText1")}
        </Typography>
        <Typography align="left" sx={standardTypo}>
          {t("welcomeProjectText2")}
        </Typography>
        <Typography align="left" sx={standardTypo}>
          {t("welcomeProjectText3")}
        </Typography>
        <Typography align="left" sx={standardTypo}>
          {t("welcomeProjectText4")}
        </Typography>
        {/* <Typography variant="h3" align="left" sx={standardTypo}>
          {t("navigationCat12")}
        </Typography>
        <Box sx={{mb: 2}}>
          <Typography align="left" sx={standardTypo}>
            {t("welcomeProjectText7")}
          </Typography>
          <Button
            startIcon=<School />
            onClick={() => navigate(toPublications)}
            variant="contained"
            color="secondary"
          >
            {t("navigationCat12")}
          </Button>
        </Box> */}
        <Typography variant="h3" align="left" sx={standardTypo}>
          {t("welcomeProjectText5")}
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", mb: 5 }}>
          <PersonCard
            small
            img={Gudrun_Faller}
            university="Hochschule für Gesundheit Bochum"
            title="Prof.'in"
            name="Gudrun Faller"
            mail="gudrun.faller@hs-gesundheit.de"
            link="https://gudrun-faller.de/"
          />
          <PersonCard
            small
            img={Laura_Geiger}
            university="Hochschule für Gesundheit Bochum"
            title="M.A."
            name="Laura Geiger"
            mail="laura.geiger@hs-gesundheit.de"
          />
          <PersonCard
            small
            img={Valentin_Grimm}
            university="Technische Hochschule OWL"
            title="M.Sc."
            name="Valentin Grimm"
            link="https://www.th-owl.de/umwelt/fachbereich/team/valentin-grimm/"
            phone="+49 5271 687 5032"
            mail="valentin.grimm@th-owl.de"
          />
          <PersonCard
            small
            img={Jessica_Rubart}
            university="Technische Hochschule OWL"
            title="Prof.'in"
            name="Jessica Rubart"
            link="https://www.th-owl.de/umwelt/fachbereich/team/jessica-rubart/"
            phone="+49 5271 687 7870"
            mail="jessica.rubart@th-owl.de"
          />
        </Box>
        <Typography variant="h3" align="left" sx={{ my: 2 }}>
          {t("welcomeProjectText6")}
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
          <PartnerCard src={TH_OWL} link="https://www.th-owl.de/" />
          <PartnerCard
            src={HSG}
            link="https://www.hs-gesundheit.de/forschung/aktuelle-projekte/gekonnt-handeln "
          />
          <PartnerCard src={MJZ} link="https://www.minijob-zentrale.de/" />
          <PartnerCard src={UK_NRW} link="https://www.unfallkasse-nrw.de/" />
        </Box>
        <Publications />
      </Box>
    </Box>
  );
}
